import React, { useState } from "react";
import { db } from "../firebaseConfig";
import { collection, addDoc, serverTimestamp } from "firebase/firestore"
import "./Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    whatsappNumber: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // -----------------------------
  // HANDLE FORM SUBMIT
  // -----------------------------
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    try {
      await addDoc(
        collection(
          db,
          "workspaces",
          "AfDsQf3a4HNfZrIY28qrTnNPUzN2",
          "websites",
          "f2v0M4bYufyU4t6IQh04",
          "messages"
        ),
        {
          name: formData.name,
          phone: formData.whatsappNumber,
          whatsappNumber: formData.whatsappNumber,
          message: formData.message,
  
          toMail: "mbalimapaila@icloud.com",
          status: "new",
          source: "fleur-contact-form",
          createdAt: serverTimestamp(),
        }
      );
  
      setFormData({
        name: "",
        whatsappNumber: "",
        message: "",
      });
  
      alert("Message sent successfully!");
    } catch (error) {
      console.error("Error sending message:", error);
      alert("Something went wrong. Please try again.");
    }
  
    setLoading(false);
  };  

  return (
    <section id="contact" className="contact">
      <div className="contact-card">
        <h2 className="contact-title">Get in Touch</h2>
        <p className="contact-subtitle">Let's talk about your next shoot.</p>

        <form className="contact-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Name & Surname"
            value={formData.name}
            className="contact-input"
            onChange={handleChange}
            required
          />

          <input
            type="whatsappNumber"
            name="whatsappNumber"
            placeholder="WhatsApp Number"
            value={formData.whatsappNumber}
            className="contact-input"
            onChange={handleChange}
            required
          />

          <textarea
            name="message"
            placeholder="How can we help?"
            value={formData.message}
            className="contact-textarea"
            onChange={handleChange}
            required
          ></textarea>

          <button
            type="submit"
            className="contact-submit"
            disabled={loading}
          >
            {loading ? "Sending..." : "Send Message"}
          </button>
        </form>

        <div className="contact-buttons">
          <a
            href="https://wa.me/27828179265?text=Hi%2C%20please%20tell%20me%20more%20about%20your%20services."
            target="_blank"
            rel="noopener noreferrer"
            className="contact-btn whatsapp-btn"
          >
            WhatsApp Us
          </a>

          <a href="tel:+27600000000" className="contact-btn call-btn">
            Call Us
          </a>
        </div>

        {/* -------------------------MAP SECTION------------------------- */}
        <div className="contact-map">
          <iframe
            title="Our Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3592.310767892423!2d29.43356211182751!3d-25.793319677237562!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1eea601431dc01f9%3A0x885e488275aeece5!2s48%20Grootvis%20St%2C%20Aerorand%2C%20Middelburg%2C%201055!5e0!3m2!1sen!2sza!4v1766047655767!5m2!1sen!2sza"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </section>
  );
};

export default Contact;
